module.exports = __webpack_public_path__ + "static/19-ed58d74b65785cc613ace90511f1da2c.jpeg";